/**
 * Jersey Customization Validation & Price Calculation
 * Validates name and number fields and shows price breakdown
 */

(function() {
  'use strict';

  if (typeof jQuery === 'undefined') return;

  var $ = jQuery;
  var $document = $(document);

  // Initialize on page load
  $document.ready(function() {
    initJerseyCustomization();
  });

  function initJerseyCustomization() {
    var $nameField = $('[data-custom-name-field]');
    var $numberField = $('[data-custom-number-field]');

    if ($nameField.length === 0 && $numberField.length === 0) {
      return; // No customization fields on this page
    }

    // Add validation to name field
    if ($nameField.length) {
      $nameField.on('input', function() {
        validateNameField($(this));
      });
      
      $nameField.on('blur', function() {
        validateNameField($(this));
      });
    }

    // Add validation to number field
    if ($numberField.length) {
      $numberField.on('input', function() {
        validateNumberField($(this));
      });
      
      $numberField.on('blur', function() {
        validateNumberField($(this));
      });
    }

    // Validate on form submit
    $('form[data-type="add-to-cart-form"]').on('submit', function(e) {
      var isValid = true;
      
      if ($nameField.length) {
        if (!validateNameField($nameField)) {
          isValid = false;
        }
      }
      
      if ($numberField.length) {
        if (!validateNumberField($numberField)) {
          isValid = false;
        }
      }
      
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  }

  function validateNameField($field) {
    var value = $field.val().trim();
    var $parent = $field.closest('[data-item-property-field]');
    var $error = $parent.find('.bee-customization-error');
    
    // Remove existing error
    $error.remove();
    $field.removeClass('bee-input-error');

    // Check if required and empty
    if ($field.prop('required') && !value) {
      showError($field, $parent, 'Name is required');
      return false;
    }

    // Check length
    if (value && value.length > 20) {
      showError($field, $parent, 'Name must be 20 characters or less');
      return false;
    }

    // Check for invalid characters (alphanumeric and spaces only)
    if (value && !/^[a-zA-Z0-9\s]+$/.test(value)) {
      showError($field, $parent, 'Name can only contain letters, numbers, and spaces');
      return false;
    }

    return true;
  }

  function validateNumberField($field) {
    var value = $field.val().trim();
    var $parent = $field.closest('[data-item-property-field]');
    var $error = $parent.find('.bee-customization-error');
    
    // Remove existing error
    $error.remove();
    $field.removeClass('bee-input-error');

    // Check if required and empty
    if ($field.prop('required') && !value) {
      showError($field, $parent, 'Number is required');
      return false;
    }

    // Check if numeric only
    if (value && !/^\d+$/.test(value)) {
      showError($field, $parent, 'Number must contain only digits');
      return false;
    }

    // Check length
    if (value && value.length > 3) {
      showError($field, $parent, 'Number must be 3 digits or less');
      return false;
    }

    // Check range (0-999)
    if (value && (parseInt(value) < 0 || parseInt(value) > 999)) {
      showError($field, $parent, 'Number must be between 0 and 999');
      return false;
    }

    return true;
  }

  function showError($field, $parent, message) {
    $field.addClass('bee-input-error');
    
    var $error = $('<div class="bee-customization-error" style="color: #d32f2f; font-size: 12px; margin-top: 4px;">' + message + '</div>');
    $parent.append($error);
  }

})();

